//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid } from '@material-ui/core';
// import { useHistory } from 'react-router-dom';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
// import { AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { SEND_IT_AGAIN } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdLink from '../../common/elemental/AfitdLink';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import MailOutlineIcon from '@material-ui/icons/MailOutline';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import Header from './subComponents/Header';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: { width: '100%', maxWidth: 570, marginTop: 50 },
    sendEmailAgainLink: { textDecoration: 'underline', fontWeight: 'bold' },
    content: { textAlign: 'center' },
    title: { fontSize: 26, marginTop: 32, fontWeight: 'bold' },
    message: { fontSize: 16, marginTop: 16, marginBottom: 57 },
    mainIcon: { fontSize: 93, color: 'rgba(216, 216, 216, 1)' },
    secondIcon: { background: 'rgba(29, 138, 139, 1)', color: '#fff', borderRadius: '50%', fontSize: 32, padding: 2, marginLeft: ' -62px', marginTop: '0px' },
    iconContainer: { display: 'flex', justifyContent: 'center' },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        // props,
        handleClickResendButton,
    } = params;

    const defns = {
        root: { container: true, justify: 'center' },
        content: { item: true, xl: 10, lg: 10, md: 10, sm: 11, xs: 11 },
        title: { variant: 'h5', clsSkinnyBold: true /* clsLightBold: true */ },
        message: { variant: 'body1' },
        needAnotherLinkText: { variant: 'body1', component: 'span' },
        sendEmailAgainLink: {
            color: 'secondary',
            onClick: handleClickResendButton,
            label: SEND_IT_AGAIN,
        },
        secondIcon: {},
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const SignUpSuccessful = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    // const appContext = useContext(AppContext);
    // const context = useContext(LayoutContext);

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleClickResendButton = async () => {
        alert('(Fake) Email sent! It might take up to 10 minutes for it to arrive your inbox.');
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, handleClickResendButton });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Grid {...defns.root}>
            <Grid {...defns.content}>
                <div {...defns.iconContainer}>
                    <MailOutlineIcon {...defns.mainIcon} />
                    <ArrowDownwardIcon {...defns.secondIcon} />
                </div>
                <AfitdTypography {...defns.title}>Great! You've successfully signed up</AfitdTypography>
                <AfitdTypography {...defns.message}>
                    We've sent you a link to confirm your email address. Please check your inbox. It could take up to 10 minutes to show up in your inbox. Didn't get the email?
                    Please check your spam folder.
                </AfitdTypography>
                <AfitdTypography {...defns.needAnotherLinkText}>
                    Still don't have the Email? <AfitdLink {...defns.sendEmailAgainLink} />
                </AfitdTypography>
            </Grid>
        </Grid>
    );
};

export default SignUpSuccessful;
